import { Heading, Text, Button, VStack, HStack, Tag } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { REFERRAL_DISCOUNT } from "@syla/shared/types/helpers/constants";
import React from "react";
import { useHistory } from "react-router-dom";
import { useGetReferralCode } from "../../../helper/useGetReferralCode";
import { SylaLogo } from "./SylaFormHeader";

export const Form = styled.form`
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
`;

export const SignUpToSyla = () => {
  const referralCodeParam = useGetReferralCode();

  // quick fix to allow 30% offer
  const discount =
    referralCodeParam === "CRYPTOCON24" ? "30%" : REFERRAL_DISCOUNT;

  return (
    <VStack alignItems="flex-start">
      <HStack>
        <SylaLogo />
        <Heading>Sign up</Heading>
      </HStack>
      {referralCodeParam && (
        <HStack
          bgColor="green.100"
          p="0.3rem"
          color="green.800"
          borderRadius={"16px"}
        >
          <Tag
            bgColor="white"
            color="green.800"
            fontWeight="bold"
            borderRadius={"16px"}
          >
            ${discount}
          </Tag>
          <Text bgColor="green.100">
            {"You'll"} get a ${discount} discount on your plan 🎉
          </Text>
        </HStack>
      )}
    </VStack>
  );
};

export const SignInAndTermsLinks = ({ disabled }: { disabled?: boolean }) => {
  const history = useHistory();

  return (
    <>
      <Text mt="10px" mb="20px">
        {"Already have an account? "}
        <Button
          color="primary.500"
          disabled={disabled}
          onClick={() => history.push("/sign-in")}
          variant="link"
        >
          Sign in
        </Button>
      </Text>
      <Text fontSize="0.8rem" color="black.500">
        {"By signing up with Syla, you agree to our "}
        <Button
          color="primary.500"
          disabled={disabled}
          fontSize="0.8rem"
          fontWeight="normal"
          onClick={() =>
            window.open("https://www.syla.com.au/terms-of-service")
          }
          variant="link"
        >
          Terms of Service
        </Button>
      </Text>
    </>
  );
};
